// Avisos de sinal e de envio: a barra embaixo do topo, a marca "esperando
// envio" nos cartões e a confirmação de saída com alterações não enviadas.
import { h, trocar } from '../lib/dom.js';
import { aoMudar, estado } from '../local/sincronia.js';
import { alteracoesNaoEnviadas } from '../sessao.js';
import { confirmar, emblema } from './componentes.js';

function contagem(n, uma, varias) {
  return n === 1 ? `1 ${uma}` : `${n} ${varias}`;
}

// Barra fina embaixo do topo. Some quando está tudo enviado e há sinal.
export function barraDeSinal() {
  const barra = h('div', { class: 'barra-sinal', role: 'status', 'aria-live': 'polite', hidden: true });
  let montada = false;
  const atualizar = () => {
    if (montada && !barra.isConnected) {
      desligar();
      return;
    }
    const { online, enviando, pendentes, recusadas } = estado;
    let tipo = null;
    let conteudo = null;
    if (recusadas > 0) {
      tipo = 'perigo';
      conteudo = [
        h('span', null, contagem(recusadas, 'alteração não foi aceita', 'alterações não foram aceitas')),
        h('a', { href: '#/pendencias' }, 'Ver'),
      ];
    } else if (!online) {
      tipo = 'alerta';
      conteudo = pendentes > 0
        ? `Sem sinal · ${contagem(pendentes, 'alteração esperando envio', 'alterações esperando envio')}`
        : 'Sem sinal. Pode continuar: o que fizer fica guardado e vai quando o sinal voltar.';
    } else if (pendentes > 0) {
      tipo = 'info';
      conteudo = enviando
        ? `Enviando ${contagem(pendentes, 'alteração', 'alterações')}…`
        : [h('span', null, contagem(pendentes, 'alteração esperando envio', 'alterações esperando envio')), h('a', { href: '#/pendencias' }, 'Ver')];
    }
    barra.hidden = !tipo;
    barra.className = `barra-sinal${tipo ? ` ${tipo}` : ''}`;
    trocar(barra, conteudo);
  };
  const desligar = aoMudar(atualizar);
  queueMicrotask(() => {
    montada = true;
    atualizar();
  });
  return barra;
}

// Marca no cartão de um registro que ainda não chegou ao servidor.
export function emblemaEnvio(situacao) {
  if (situacao === 'recusada') return emblema('Não aceito', 'perigo');
  if (situacao === 'pendente') return emblema('Esperando envio', 'alerta');
  return null;
}

// Antes de sair: se há alterações que ainda não subiram, avisa que se perdem.
export async function confirmarSaida() {
  const n = await alteracoesNaoEnviadas();
  if (n === 0) {
    return confirmar({ titulo: 'Sair do HSA Frota?', texto: 'Para entrar de novo, é só pedir um código no seu e-mail.', sim: 'Sair' });
  }
  return confirmar({
    titulo: 'Sair com alterações não enviadas?',
    texto:
      n === 1
        ? '1 alteração feita neste aparelho ainda não chegou ao servidor. Se sair agora, ela se perde. Espere o sinal voltar para ela ser enviada.'
        : `${n} alterações feitas neste aparelho ainda não chegaram ao servidor. Se sair agora, elas se perdem. Espere o sinal voltar para elas serem enviadas.`,
    sim: 'Sair mesmo assim',
    perigo: true,
  });
}

export { estado as estadoDoEnvio };
